"use strict";

// Информация о ФИО

import utils from "../utils";

var GENDER_SIGN = {
    MALE: "♂",
    FEMALE: "♀",
    UNKNOWN: "❓",
};

var GENDER_DESCRIPTION = {
    MALE: "мужской",
    FEMALE: "женский",
    UNKNOWN: "неизвестен",
};

function isPatronymicAllowed(fio) {
    return fio.surname && fio.name && !fio.patronymic;
}

var self = {
    fullname: function (fio) {
        return utils.join([fio.surname, fio.name, fio.patronymic], " ");
    },

    gender: function (fio) {
        if (["MALE", "Мужской", "М"].indexOf(fio.gender) !== -1) {
            return "MALE";
        }
        if (["FEMALE", "Женский", "Ж"].indexOf(fio.gender) !== -1) {
            return "FEMALE";
        }
        return "UNKNOWN";
    },

    genderSign: function (fio) {
        return GENDER_SIGN[self.gender(fio)];
    },

    genderDescription: function (fio) {
        return GENDER_DESCRIPTION[self.gender(fio)];
    },

    genderWithSign: function (fio) {
        return self.genderSign(fio) + " " + self.genderDescription(fio);
    },

    isGood: function (fio) {
        return (fio.qc === null || fio.qc.toString() === "0") && fio.surname && fio.name;
    },

    validationMessage: function (fio) {
        var message = "отлично!";
        if (!fio.surname) {
            message = "укажите фамилию";
        } else if (!fio.name) {
            message = "укажите имя";
        } else if (fio.qc && fio.qc.toString() !== "0") {
            message = "неизвестное ФИО";
        } else if (isPatronymicAllowed(fio)) {
            message = "еще можно указать отчество";
        }
        return message;
    },
};

export default self;
